import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";

const ease = [0.16, 1, 0.3, 1];

export default function Rsvp() {
  return (
    <section id="rsvp" className="bg-paper text-ink py-24 sm:py-36">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <SectionHeading number="05" kicker="Acompáñanos" title="Confirma tu Asistencia" />

        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease }}
              className="font-display italic text-2xl sm:text-3xl leading-snug text-ink"
            >
              “Nos encantaría celebrar este día contigo.”
            </motion.p>
            <p className="mt-6 text-sm font-light text-[color:var(--muted)]">
              La confirmación es privada, mediante tu invitación personal.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="border border-black/15 p-10 sm:p-12" data-testid="rsvp-closed-note">
              <p className="overline text-[color:var(--muted)]">Confirmación por invitación</p>
              <h3 className="font-display text-3xl sm:text-4xl mt-4">Solo con tu enlace personal</h3>
              <p className="font-light text-[color:var(--muted)] mt-4 max-w-md leading-relaxed">
                Para cuidar el aforo, la confirmación es privada. Usa el enlace personal que te enviamos por WhatsApp o correo para confirmar tu asistencia y la de tus acompañantes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
